import { Nullable } from "common/records";
import { DiscountGroupMap } from "common/reducers/pricePresentation.reducer";
import { FormUpdateEvent } from "common/reducers/rsfForm.actions";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { List } from "immutable";

export const ADD_DISCOUNT_GROUP = "@pricePresentation/ADD_DISCOUNT_GROUP";
export const RESET_EDIT_DISCOUNT_FORM = "@pricePresentation/RESET_EDIT_DISCOUNT_FORM";
export const RESET_PRICE_PRESENTATION = "@pricePresentation/RESET_PRICE_PRESENTATION";
export const SET_CURRENT_SLIDE_INDEX = "@pricePresentation/SET_CURRENT_SLIDE_INDEX";
export const SET_SELECTED_ESTIMATE_ID = "@pricePresentation/SET_SELECTED_ESTIMATE_ID";
export const SET_SLIDE_ESTIMATE_IDS = "@pricePresentation/SET_SLIDE_ESTIMATE_IDS";
export const UPDATE_FINANCING = "@pricePresentation/UPDATE_FINANCING";
export const UPDATE_PRICE_PRESENTATION = "@pricePresentation/UPDATE_PRICE_PRESENTATION";

export const PricePresentationActions = {
  addDiscountGroup: (group: DiscountGroupMap) => createAction(ADD_DISCOUNT_GROUP, { group }),
  resetEditDiscountForm: () => createAction(RESET_EDIT_DISCOUNT_FORM),
  resetPricePresentation: () => createAction(RESET_PRICE_PRESENTATION, {}),
  setCurrentSlideIndex: (index: number) => createAction(SET_CURRENT_SLIDE_INDEX, { index }),
  setSelectedEstimateId: (estimateId: Nullable<number>) => createAction(SET_SELECTED_ESTIMATE_ID, { estimateId }),
  setSlideEstimateIds: (ids: List<number>) => createAction(SET_SLIDE_ESTIMATE_IDS, { ids }),
  updateFinancing: (total: number) => createAction(UPDATE_FINANCING, { total }),
  updatePricePresentation: (event: FormUpdateEvent) => createAction(UPDATE_PRICE_PRESENTATION, { event }),
};

export type PricePresentationActions = ActionsUnion<typeof PricePresentationActions>;
